export default {
  AddressType: 'نوع آدرس',
  CountryRemoved: 'کشور حذف شد',
  NewCountryAdd: 'کشور جدید اضافه شد',
  NewCityAdd: 'شهر جدید اضافه شد',
  CityRemoved: 'شهر حذف شد',
  CountyName: 'نام شهرستان',
  Faild: 'ناموفق',
  NewProvinceAdd: 'استان جدیداضافه شد',
  UpdateCountry: 'کشور بروز رسانی شد',
  UpdateCity: 'شهر بروزرسانی شد',
  UpdateProvince: 'استان بروزرسانی شد',
  ProvinceRemoved: 'استان حذف شد',
  ZonsRemove: 'منطقه حذف شد',
  UpdateZons: 'منطقه بروزرسانی شد',
  NewZonsAdd: 'منطقه جدید اضافه شد',
  NewAddressAdd: 'آدرس جدید اضافه شد',
  UpdateAddress: 'آدرس بروز رسانی شد',
  RemoveAddress: 'آدرس حذف شد',
  EditFor: 'ثبت آدرس',
  Addresses: 'آدرس ها',
  Address: 'آدرس',
  CountryName: 'کشور',
  CityName: 'نام شهر',
  Citys: 'شهر',
  City: 'شهر',
  Enable: 'فعال',
  Disable: 'غیر فعال',
  Latitude: 'عرض جغرافیایی',
  Longitude: 'طول جغرافیایی',
  Location: 'موقعیت',
  ProvinceName: 'نام استان',
  Provinces: 'استان',
  PostalCode: 'کدپستی',
  Phone: 'تلفن',
  Priority: 'اولویت',
  Slug: 'Slug',
  Order: 'ترتیب',
  OriginalAddress: 'آدرس اصلی ',
  Title: 'عنوان',
  ZoneName: 'نام منطقه',
  Zons: 'مناطق',
  areYouSureYouWantToDeleteThisAddress: 'آیا از حذف این آدرس اطمینان دارید؟',
  mainAreas: 'نواحی اصلی',
  suburbsAreas: 'نواحی حومه',
  area: 'ناحیه',
  newArea: 'ناحیه جدید',
  systematicExpand: 'گسترش سیستمی',
  extensionRadius: 'شعاع گسترش',
  zone: 'منطقه',

  provinceName: 'نام استان',
  countryName: 'کشور',
  postalCode: 'کدپستی',
  cityName: 'نام شهر',
  phone: 'تلفن',
  originalAddress: 'آدرس اصلی ',
  location: 'موقعیت',
  address: 'آدرس',
  province: 'استان',
  city: 'شهر',
  countryId: 'شناسه کشور',
  provinceId: 'شناسه استان',
  countyId: 'شناسه شهرستان',
  cityId: 'شناسه شهر',
  districtId: 'شناسه منطقه',
  trafficPlanId: 'شناسه طرح ترافیک',
  addresses: 'آدرس ها',
  online: 'آنلاین',
  offline: 'آفلاین',
  failureToUpdateLocation: 'عدم بروزرسانی موقعیت',
  failureToPostLocation: 'عدم ارسال موقعیت'
}